// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumText-cls1_tlt","cls2":"PremiumText-cls2_n0O PremiumText-cls1_tlt"};